import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';

// tslint:disable:no-unused-expression
const generateStyleForColor = (prefix: string, color: string) => ({
  [`${prefix}root`]: {
    color,
    textDecoration: 'none',
    '&:hover *': {
      color: [[color], '!important'],
    },
  },
  [`${prefix}active`]: {
    '& *': {
      color: [[color], '!important'],
    },
  },
});

const styles = (theme: Theme) =>
  createStyles({
    ...generateStyleForColor('dark', '#FFB200'),
    ...generateStyleForColor('light', theme.palette.secondary.main),
    underline: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  });

interface Properties extends WithStyles<typeof styles> {
  children: any;
  classes: any;
  theme: any;
  className: any;
  active: boolean;
  variant?: 'dark' | 'light';
  href?: string;
}

class Anchor extends React.Component<Properties, {}> {
  public render() {
    const { children, classes, className, active, ...props } = this.props;
    let { variant } = this.props;

    variant = variant || 'light';

    const allClasses = [className, classes[`${variant}root`]];
    active && allClasses.push(classes[`${variant}active`]);
    typeof children === 'string' && allClasses.push(classes.underline);

    return (
      <a className={allClasses.filter((e) => e).join(' ')} {...props}>
        {children}
      </a>
    );
  }
}

const enhance = compose<any, Properties>(withStyles(styles));

export default enhance(Anchor);
